export class TransactionFilterDto {
    public categories: string[];
    public types: string[];
    public pageNumber: Number;
    public pageSize: Number;
}